'use client';
import React, { useEffect, useLayoutEffect } from 'react';

import loadBackgroudImages from '../../common/loadBackgroudImages';
function Header() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <header
      className="header-personal valign bg-img"
      data-background="/assets/imgs/background/bg10.jpg"
      data-overlay-dark="2"
    >
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-7">
            <div className="caption">
              {/* <h6 className="mb-15">
                <span className="icon-img-30 mr-10">
                  <img src="/assets/imgs/header/hi.png" alt="" />
                </span>{' '}
                Hello! there
              </h6> */}
              <h1 className="fw-700 mb-10">
                PROFILE <span className="main-color">MGMT</span>
              </h1>
              <h3>Your Silent Management</h3>
              <div className="row">
                <div className="col-lg-9">
                  <div className="text mt-30">
                    <p>
                    Our mission is to provide a platform for models to showcase their unique beauty and abilities, 
                    and to connect with fans who appreciate and support their work.
                    </p>
                  </div>
                  <div className="d-flex align-items-center mt-60">
                    <a
                      href="https://profilemgmt.com/join"
                      className="butn butn-md butn-bord radius-30"
                    >
                      <span className="text">Get Started</span>
                    </a>
                    {/* <div className="icon-img-60 ml-20">
                      <img
                        src="/assets/imgs/icon-img/arrow-down-big.png"
                        alt=""
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="info d-flex align-items-center justify-content-end mt-100">
          {/* <div className="item">
            <h6 className="sub-title mb-10">Email :</h6>
            <span className="p-color">Webfolio.Info@gmail.com</span>
          </div>
          <div className="item">
            <h6 className="sub-title mb-10">Phone :</h6>
            <span className="p-color">+2 456 (343) 24 45</span>
          </div>
          <div className="item">
            <h6 className="sub-title mb-10">Address :</h6>
            <span className="p-color">5919 Trussville Pkwy, Birmingham</span>
          </div> */}
        </div>
      </div>
    </header>
  );
}

export default Header;
